const AUTH_STORAGE_VERSION_KEY = "app_storage_version";
const AUTH_STORAGE_VERSION = "auth-storage-v1";

const AUTH_STORAGE_KEYS = [
  "user",
  "token",
  "impersonation",
  "impersonator_is_superadmin",
  "impersonator_superadmin_user_id",
];
const LOGIN_RESET_UI_STORAGE_KEYS = [
  "dashboard_timeframe",
  "dashboard_start_date",
  "dashboard_end_date",
  "todos_time_filter",
  "todos_start_date",
  "todos_end_date",
];

const removeKeys = (storage: Storage | undefined) => {
  if (!storage) return;
  for (const key of AUTH_STORAGE_KEYS) {
    storage.removeItem(key);
  }
};

export const clearAuthStorage = (): void => {
  try {
    removeKeys(window.localStorage);
    removeKeys(window.sessionStorage);
  } catch {
    // Ignore storage access errors.
  }
};

export const resetLoginUiStorage = (): void => {
  try {
    for (const key of LOGIN_RESET_UI_STORAGE_KEYS) {
      window.localStorage.removeItem(key);
      window.sessionStorage.removeItem(key);
    }
  } catch {
    // Ignore storage access errors.
  }
};

export const migrateAuthStorage = (): void => {
  try {
    const currentVersion = window.localStorage.getItem(AUTH_STORAGE_VERSION_KEY);
    if (currentVersion === AUTH_STORAGE_VERSION) return;

    clearAuthStorage();
    window.localStorage.setItem(AUTH_STORAGE_VERSION_KEY, AUTH_STORAGE_VERSION);
  } catch {
    // Ignore storage access errors.
  }
};
